import { useMutation } from '@tanstack/react-query';

import { apiBaseUrl } from '../../../config';
import { FlightOperationNotificationClient } from '../../clients';
import queryKeys from '../../queryKeys';

const FonClient = new FlightOperationNotificationClient(apiBaseUrl);

function useDeleteFlightOperationNotification() {
  return useMutation({
    mutationKey: [queryKeys.FlightOperationNotification.Delete],
    mutationFn: (id: number) => FonClient.delete(id),
  });
}

export default useDeleteFlightOperationNotification;
